'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;
import { Link } from 'react-router';
import Globalize from 'globalize';
import GetMobileApp from './GetMobileApp';



var SectionIntro = React.createClass({


  getInitialState() {
    return {
      locale: this.props.locale,
      images: []
    };
  },

  handleLocaleChange: function (language) {
    this.setState({
      locale: language
    });
  },

  loadImagesFromServer() {
    $.ajax({
      url: '/api/carousel',
      type: 'POST',
      dataType: 'json',
      cache: false,
      success: function (data) {
        this.setState({ images: data });
      }.bind(this),
      error: function (xhr, status, err) {
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  },

  renderThumbnail(src, image, message, desc, external) {
    //if (this.props.grantedAccess[src]) {
    if (external) {
      src = "https://" + src;
    }
    return (

      <div className="thumbnail">
        <a href={src}>
          <img src={"./img/" + image} alt={desc} className="img-responsive" />
          {/* <div className="caption">
              <h3><FormatMessage locale={this.props.locale} path={message} /></h3>
            </div> */}
        </a>
      </div>
    )
    //}
  },

  

  componentDidMount() {
    this.loadImagesFromServer();

    
  },

  /**
   * @return {object}
   */
  render: function () {

    var androidActImage = 'img/android/google-play-badge-es.png';
    var appleActImage = 'img/apple/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.svg';

    if (this.props.locale != 'es') {
      androidActImage = "img/android/google-play-badge.png";
      appleActImage = 'img/apple/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
    }

    let prodUrl = "www.barrimoneytransfer.com";
    let testUrl = "mbdesa.barrigroup.com";

    let url = prodUrl;

    let imgStores = this.props.locale == "es" ? "stores_es.png" : "stores_en.png"
    let imgInternet = this.props.locale == "es" ? "web_es.png" : "web_en.png"
    let imgApps = this.props.locale == "es" ? "app_es.png" : "app_en.png"

    return (

      <div id="section0" className="main-content indexvariant">
        
        <div className="container">
        <GetMobileApp locale={this.props.locale}/>
          <div className=" row iconsRow" style={{}}>
            <div className="col-md-4">
              {/* {this.renderThumbnail("www.barrimoneytransfer.com/mb/initialquote?loc=" + this.props.locale, "ICONOCOTIZADOR2.png", "menu/quoteWire", "Description of the product")}
              {this.renderThumbnail("www.barrimoneytransfer.com/mb/login?internal=sendMoney&loc=" + this.props.locale, "iconoWorld2.png", "menu/menuSendMoneyLink", "Description of the product")}
              {this.renderThumbnail("www.barrimoneytransfer.com/mb/login?internal=transactions&loc=" + this.props.locale, "ICONOBUSCADOR2.png", "menu/menuSearch", "Description of the product")} */}
              {this.renderThumbnail("./locations", imgStores, "menu/quoteWire",
                Globalize(this.props.locale).formatMessage("barriPage/imgOurStores"))}
              {/* "Envía dinero desde nuestras tiendas o agencias" */}
            </div>
            <div className="col-md-4">
              {this.renderThumbnail(url + "/mb/login?internal=sendMoney&loc=" + this.props.locale, imgInternet, "menu/menuSendMoneyLink",
                Globalize(this.props.locale).formatMessage("barriPage/imgInternet"), true)}
            </div>
            <div className="col-md-4">
              {this.renderThumbnail(url + "/apps?loc=" + this.props.locale, imgApps, "menu/menuSearch",
                Globalize(this.props.locale).formatMessage("barriPage/imgAppMobile"),
                true)}
            </div>

            {/* <div className="col-md-10 col-md-offset-1" style={{ "margin-top": "90px;", "margin-bottom": "15px;" }}>
              <div className="col-md-2 col-md-offset-4 col-xs-6 text-right">
                <a href="https://play.google.com/store/apps/details?id=com.barrigroup.barrimobile.a01"
                  target="_blank">
                  <img src={androidActImage}
                    width="auto" height="40" className="img-responsive"
                    style={{
                      "height": "40px"
                    }}
                    alt="Get it on Google Play"
                  />
                </a>
              </div>
              <div className="col-md-2 col-md-offset-0 col-xs-6 text-center">
                <a href="https://itunes.apple.com/us/app/barrimobile/id1291545810?ls=1&mt=8" target="_blank">
                  <img src={appleActImage}
                    width="auto" height="40"
                    className="img-responsive"
                    style={{
                      "display": "initial",
                      "height": "40px"
                    }}
                    alt="Download on the App Store"
                  />
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    )
  }

});


module.exports = SectionIntro



// WEBPACK FOOTER //
// ./js/sectionIntro.js